import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import notificationService from "../services/notificationService";

const Home = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const expiringIngredients = notificationService.getExpiringSoon();
        const lowStockIngredients = notificationService.getLowStock(); // ✅ Přidáno

        if (expiringIngredients.length > 0 || lowStockIngredients.length > 0) { // ✅ Změna
            navigate("/notifications");
        } else {
            navigate("/ingredients");
        }
    }, [navigate]);

    return null;
};

export default Home;
